<template>
  <card-item
    card="item_transfer_container"
    :tabs="tabs"
    v-model="activeTab"
    :id="`${id}${$store.state.user.sections['transfers'] ? '' : '000030003'}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Контейнер",
          key: "container",
          component: () => import("./Info"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>